import React from 'react';
import './version.css';

class Version extends React.Component {
    constructor() {
        super();

        this.state = {
            ver: process.env.VERSION.replace(/"/g, ''),
            hash: process.env.COMMITHASH.substr(1, 7),
        };
    }

    render() {
        const { ver, hash } = this.state;
        return ver ?
            <div className="version">{ver}-{hash}</div> :
            <div />;
    }
}

export default Version;



// WEBPACK FOOTER //
// src/components/version/Version.js